module.exports = __webpack_public_path__ + "img/6-11.4d716304.png";